export default __webpack_public_path__ + "static/screen_5-47533be731bb8bdbfe347a2a64af4ce2.jpeg";